import { apiAction, appendQuery } from 'client/redux/apiHelpers';

export const instanceLog = (types, query) => {
  return apiAction({
    endpoint: appendQuery('/api/instance/log', query),
    method: 'GET',
    types,
  });
};
